<template>
    <div class="main-body">
        <cabecalho-padrao/>
    
        <section class="sub-menu-body">
            <sub-menu/>
            <div class="main">

              <div class="form-novo">
                <div class="header">
                    <h1>Lista Cartão de Crédito</h1>
                </div>
                <div class="card -semfundo">
                    <button type="button" @click="Novo()">Novo Cartão</button>
                </div>                 
                <div class="card" v-for="cartao in listaCartaoCredito" :key="cartao.cod_cartao" >
                    <div class="wrapper-list" v-if="cartao.cod_cartao!=dados.codCartao">
                        <div>
                            <h2>{{cartao.nome_cartao}}({{ cartao.cod_cartao }}) - Próximo Vencimento {{ formatarParaTexto(cartao.mes_aberto) }}.</h2> 
                        </div>
                        <div>
                            <button type="button" @click="Alterar(cartao.id-1)">Alterar</button>
                            <button type="button" class="-vermelho" @click="Excluir(cartao.id-1)">Excluir</button>
                        </div>
                    </div>
                    <div v-if="cartao.cod_cartao==dados.codCartao">
                        <div class="input-group">
                            <label>Nome Cartão</label>
                            <input type="text" v-model="dados.nomeCartao" maxlength="20">
                        </div>
                        <div class="group-colunas">
                            <div class="input-group">
                                <label>Dia do Fechamento</label>
                                <input type="text" v-model="dados.diaFechamento" @input="dados.diaFechamento = $event.target.value.replace(/\D/g, '')" maxlength="2">
                            </div>                           
                            <div class="input-group">
                                <label>Dia do Vencimento</label>
                                <input type="text" v-model="dados.diaVencimento" @input="dados.diaVencimento = $event.target.value.replace(/\D/g, '')" maxlength="2">
                            </div>  
                        </div>
                        <div class="input-group">
                            <label>Mês Aberto</label>  
                            <input type="date" v-model="dados.mesAberto" >  
                        </div>   
                        <div class="button-group">
                              <button type="button" @click="Salvar()">Salvar</button>
                              <button type="button" class="-vermelho" @click="Fechar()">Fechar</button>
                          </div>                                                                     
                    </div>
                </div>
              </div>    

            </div>
        </section>

    </div>
</template>

<script>
import CabecalhoPadrao from '../../components/Cabecalho.vue';
import subMenuPagar from '../../components/subMenuPagar.vue';
import api from '../../services/api.js';

export default {
  name: 'Mais',
  components:{
    'cabecalho-padrao': CabecalhoPadrao,
    'sub-menu': subMenuPagar
  },
  data: () => ({
            dados:{
                id:0,
                codCartao:0,
                nomeCartao:'',
                diaFechamento:0,
                diaVencimento:0,
                mesAberto:''
       
            },
            listaCartaoCredito:[],      

  }),
  methods: {
        Novo(){
            //verificar se já existe o ultimo registro como novo cartão
            if (this.listaCartaoCredito[this.listaCartaoCredito.length-1].cod_cartao!=0){
                const hoje = new Date();
                const ano = hoje.getFullYear();
                const mes = String(hoje.getMonth() + 1).padStart(2, '0');
                const dia = String(hoje.getDate()).padStart(2, '0');

                this.listaCartaoCredito.push({
                        id: this.listaCartaoCredito.length+1,
                        cod_cartao: 0,
                        nome_cartao: "",
                        dia_fechamento: dia,
                        dia_vencimento: dia,
                        mes_aberto: ano+"-"+mes+"-"+dia

                });
                this.Alterar(this.listaCartaoCredito.length-1);
            }
        },
        Alterar(id){
            this.dados.id            = id;
            this.dados.codCartao     = this.listaCartaoCredito[id].cod_cartao;
            this.dados.nomeCartao    = this.listaCartaoCredito[id].nome_cartao;
            this.dados.diaFechamento = this.listaCartaoCredito[id].dia_fechamento;
            this.dados.diaVencimento = this.listaCartaoCredito[id].dia_vencimento;
            this.dados.mesAberto     = this.listaCartaoCredito[id].mes_aberto;

        },
        async Excluir(id){
            let codigo     = this.listaCartaoCredito[id].cod_cartao;
            let url = `cartaocredito/${codigo}`;
            try {
                const response = await api.delete(url);
                this.listaCartaoCredito.splice(id);

            } catch (error) {
                if (error.response) {
                    // Erros de resposta do servidor
                    if (error.response.status === 400) {
                        alert(error.response.data.erro)
                    // Trate o erro específico aqui
                    } else {
                        console.error(`Erro ${error.response.status}:`, error.response.data);
                    }
                } else if (error.request) {
                    // Requisição foi feita, mas não houve resposta
                    console.error('Sem resposta do servidor:', error.request);
                } else {
                    // Outro tipo de erro
                    console.error('Erro inesperado:', error.message);
                }
            }    
        },
        Fechar(){
            if (this.dados.codCartao==0)
                this.listaCartaoCredito.splice(this.listaCartaoCredito.length-1)
            else
            {
                this.listaCartaoCredito[this.dados.id].cod_cartao     = this.dados.codCartao;
                this.listaCartaoCredito[this.dados.id].nome_cartao    = this.dados.nomeCartao;
                this.listaCartaoCredito[this.dados.id].dia_fechamento = this.dados.diaFechamento;
                this.listaCartaoCredito[this.dados.id].dia_vencimento = this.dados.diaVencimento;
                this.listaCartaoCredito[this.dados.id].mes_aberto     = this.dados.mesAberto;
            }
            this.dados.id            = 0;
            this.dados.codCartao     = '0';
            this.dados.nomeCartao    = '';
            this.dados.diaFechamento = 0;
            this.dados.diaVencimento = 0;
            this.dados.mesAberto     = '';
        },
        async Salvar(){
            let url = `cartaocredito`;
            try {
                const response = await api.post(url,this.dados);
                console.log(response.data.codigo);
                this.dados.codCartao = response.data.codigo;              
                this.Fechar();

            } catch (error) {
                if (error.response) {
                    // Erros de resposta do servidor
                    if (error.response.status === 400) {
                        alert(error.response.data.erro)
                    // Trate o erro específico aqui
                    } else {
                        console.error(`Erro ${error.response.status}:`, error.response.data);
                    }
                } else if (error.request) {
                    // Requisição foi feita, mas não houve resposta
                    console.error('Sem resposta do servidor:', error.request);
                } else {
                    // Outro tipo de erro
                    console.error('Erro inesperado:', error.message);
                }
            }  
        },
        formatarParaInputDate(dataBR) {
            const [dia, mes, ano] = dataBR.split('/');
            return `${ano}-${mes}-${dia}`;
        },        
        formatarParaTexto(data) {
            const [ano, mes, dia] = data.split('-');
            return `${dia}/${mes}/${ano}`;
        },             
        async listarCartaoCredito(){
            try {
                let url = `cartaocredito/lista`;
                const response = await api.get(url); // Aguarda a resposta da API


                this.listaCartaoCredito = response.data.qry;
                for (let i = 0; i < this.listaCartaoCredito.length; i++) 
                    this.listaCartaoCredito[i].mes_aberto = this.formatarParaInputDate(this.listaCartaoCredito[i].mes_aberto); 

            } catch (error) {
                console.log(error);
                alert('Error - listar \n' + '-' + error.response?.data || error.message);
            }
        },
    },
    
    computed: {
             
    },
    async created(){
        await this.listarCartaoCredito();
    }
}
</script>

<style>
  @import '../../css/components/sub-menu-body.css';
  @import '../../css/components/form-novo.css';

</style>